import React from 'react';
import { motion } from 'framer-motion';
import { NewspaperIcon, TrendingUpIcon, GlobeIcon, BuildingIcon, ChevronRightIcon, BookmarkIcon, ShareIcon } from 'lucide-react';
const newsItems = [{
  id: 1,
  category: 'Markets',
  title: 'Global Markets Rally on Fed Rate Decision',
  source: 'Financial Times',
  time: '15 min ago',
  image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=200&h=120&fit=crop',
  trending: true
}, {
  id: 2,
  category: 'Industry',
  title: 'Tech Giants Report Record Q4 Earnings',
  source: 'Bloomberg',
  time: '1 hour ago',
  image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=200&h=120&fit=crop',
  trending: true
}, {
  id: 3,
  category: 'Economy',
  title: 'India GDP Growth Exceeds Expectations at 7.2%',
  source: 'Economic Times',
  time: '2 hours ago',
  image: 'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=200&h=120&fit=crop',
  trending: false
}, {
  id: 4,
  category: 'Business',
  title: 'Major Merger Announced in Banking Sector',
  source: 'Reuters',
  time: '3 hours ago',
  image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=200&h=120&fit=crop',
  trending: false
}];
const getCategoryIcon = (category: string) => {
  switch (category) {
    case 'Markets':
      return <TrendingUpIcon className="w-3 h-3" data-id="element-278" />;
    case 'Industry':
      return <BuildingIcon className="w-3 h-3" data-id="element-279" />;
    case 'Economy':
      return <GlobeIcon className="w-3 h-3" data-id="element-280" />;
    default:
      return <NewspaperIcon className="w-3 h-3" data-id="element-281" />;
  }
};
export function NewsFeed() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: 0.4
  }} className="glass-card rounded-2xl p-6 h-full flex flex-col" data-id="element-282">
      {/* Header */}
      <div className="flex items-center justify-between mb-6" data-id="element-283">
        <div className="flex items-center gap-3" data-id="element-284">
          <div className="w-10 h-10 rounded-xl bg-[rgba(201,168,76,0.15)] flex items-center justify-center" data-id="element-285">
            <NewspaperIcon className="w-5 h-5 text-[#C9A84C]" data-id="element-286" />
          </div>
          <div data-id="element-287">
            <h3 className="text-lg font-semibold font-['Playfair_Display'] text-white" data-id="element-288">
              Executive Brief
            </h3>
            <p className="text-xs text-gray-400" data-id="element-289">Curated news for you</p>
          </div>
        </div>
        <div className="flex items-center gap-2 text-xs text-gray-400" data-id="element-290">
          <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse" data-id="element-291" />
          Live updates
        </div>
      </div>

      {/* News List */}
      <div className="flex-1 overflow-y-auto space-y-4 -mx-2 px-2" style={{
      maxHeight: '340px'
    }} data-id="element-292">
        {newsItems.map((news, index) => <motion.article key={news.id} initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.1 * index
      }} className="group" data-id="element-293">
            <button className="w-full text-left p-3 rounded-xl bg-[rgba(255,255,255,0.02)] hover:bg-[rgba(255,255,255,0.05)] transition-all touch-button h-auto" data-id="element-294">
              <div className="flex gap-4" data-id="element-295">
                {/* Thumbnail */}
                <div className="w-24 h-16 rounded-lg overflow-hidden flex-shrink-0 bg-[rgba(255,255,255,0.05)]" data-id="element-296">
                  <img src={news.image} alt="" className="w-full h-full object-cover" data-id="element-297" />
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0" data-id="element-298">
                  <div className="flex items-center gap-2 mb-1" data-id="element-299">
                    <span className="flex items-center gap-1 text-xs text-[#C9A84C]" data-id="element-300">
                      {getCategoryIcon(news.category)}
                      {news.category}
                    </span>
                    {news.trending && <span className="flex items-center gap-1 text-xs text-orange-400" data-id="element-301">
                        <TrendingUpIcon className="w-3 h-3" data-id="element-302" />
                        Trending
                      </span>}
                  </div>
                  <h4 className="text-sm font-medium text-white group-hover:text-[#C9A84C] transition-colors line-clamp-2" data-id="element-303">
                    {news.title}
                  </h4>
                  <div className="flex items-center gap-2 mt-2 text-xs text-gray-500" data-id="element-304">
                    <span data-id="element-305">{news.source}</span>
                    <span data-id="element-306">•</span>
                    <span data-id="element-307">{news.time}</span>
                  </div>
                </div>

                {/* Actions */}
                <div className="flex flex-col gap-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-308">
                  <button className="w-8 h-8 rounded-lg bg-[rgba(255,255,255,0.05)] hover:bg-[rgba(255,255,255,0.1)] flex items-center justify-center transition-colors" data-id="element-309">
                    <BookmarkIcon className="w-4 h-4 text-gray-400" data-id="element-310" />
                  </button>
                  <button className="w-8 h-8 rounded-lg bg-[rgba(255,255,255,0.05)] hover:bg-[rgba(255,255,255,0.1)] flex items-center justify-center transition-colors" data-id="element-311">
                    <ShareIcon className="w-4 h-4 text-gray-400" data-id="element-312" />
                  </button>
                </div>
              </div>
            </button>
          </motion.article>)}
      </div>

      {/* Footer */}
      <div className="mt-4 pt-4 border-t border-[rgba(201,168,76,0.1)] flex items-center justify-between" data-id="element-313">
        <span className="text-xs text-gray-500" data-id="element-314">Last updated: Just now</span>
        <button className="flex items-center gap-1 text-sm text-[#C9A84C] hover:text-[#D4AF37] transition-colors" data-id="element-315">
          View Full Briefing
          <ChevronRightIcon className="w-4 h-4" data-id="element-316" />
        </button>
      </div>
    </motion.div>;
}